export function getLocale() {
    return navigator.language;
}
